import React from "react";
import ReactGA from 'react-ga';
import { Link } from "react-router-dom";
import './InfoBox.css';

const InfoBox = ({ children, buttonText, buttonLink, externalLinkGAEventName }) => {

    return (

        <section className="alert-with-button info-alert">
            <div className="alert-text">
                {children}
            </div>
            {buttonText &&
                <div className="default-button alert-button alert-button-wrapper">
                    {externalLinkGAEventName ?
                        <ReactGA.OutboundLink eventLabel={externalLinkGAEventName} to={buttonLink} target="_blank">
                            {buttonText}
                        </ReactGA.OutboundLink >
                        :
                        <Link to="{buttonLink}">
                            {buttonText}
                        </Link>
                    }
                </div>
            }
            {" "}
        </section>
    )

}

export default InfoBox;